import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash'; // import cx from 'classnames'

import i18n from 'i18next';
import { useSelector, useDispatch } from 'react-redux';
import DropDown from '../ui/react-ui/dropdown';
import DataTable from '../ui/table';
import MapeDeliveryChart from './mape-delivery-chart'; // api

import { getMapeTerminalLineByWeek } from '../../api/mapeAPI'; // redux

import { setDeliveryId, setDeliveryMapeByWeek } from '../../redux/setting-mape';
var t = i18n.getFixedT(null, 'setting-mape');
var MapeDelivery = /*#__PURE__*/React.memo(function (props) {
  // redux
  var _useSelector = useSelector(function (state) {
    return state.toJS();
  }),
      contextRoot = _useSelector.envCfg.contextRoot,
      _useSelector$mape = _useSelector.mape,
      dateRange = _useSelector$mape.dateRange,
      deliveryMapeByTerminalDeliverType = _useSelector$mape.deliveryMapeByTerminalDeliverType,
      deliveryId = _useSelector$mape.deliveryId,
      terminalsList = _useSelector.app.terminalsList;

  var dispatch = useDispatch();

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      deliveryList = _useState2[0],
      setDeliveryList = _useState2[1];

  var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      deliveryMapeData = _useState4[0],
      setDeliveryMapeData = _useState4[1];

  var isMounted = useRef();
  var id = props.id,
      predictionType = props.predictionType;
  var deliveryType = {
    'PICKUP': 'PickUp',
    'RETURN': 'Return'
  };

  var handleDropDownChange = function handleDropDownChange(val) {
    dispatch(setDeliveryId(val));
  };

  useEffect(function () {
    if (!isMounted.current) return;
    var deliverId = '',
        deliverType = '';

    if (!_.isEmpty(deliveryId)) {
      var deliveryAry = deliveryId.split('-');
      deliverId = deliveryAry[0];
      deliverType = deliveryType[deliveryAry[1]];
    }

    getMapeTerminalLineByWeek(contextRoot, false, dateRange, predictionType, deliverId, deliverType).then(function (result) {
      var deliveryByWeek = _.cloneDeep(result.content).sort(function (a, b) {
        return a.day - b.day;
      });

      deliveryByWeek.unshift(deliveryByWeek.pop());
      dispatch(setDeliveryMapeByWeek(deliveryByWeek));
    });
  }, [deliveryId]);
  useEffect(function () {
    if (deliveryList.length > 0) return;
    var list = [];

    _.map(terminalsList, function (el) {
      list.push({
        value: el.value + '-PICKUP',
        text: el.text + "-".concat(t('lbl-PICKUP'))
      });
      list.push({
        value: el.value + '-RETURN',
        text: el.text + "-".concat(t('lbl-RETURN'))
      });
    });

    setDeliveryList(list);
  }, [JSON.stringify(terminalsList)]);
  useEffect(function () {
    var newData = _.cloneDeep(deliveryList);

    _.map(deliveryMapeByTerminalDeliverType, function (el) {
      var item = _.find(newData, function (o) {
        return o.value === "".concat(el.terminalId, "-").concat(el.deliverType.toUpperCase());
      });

      if (!_.isEmpty(item)) item.mape = Math.round(el.mape * 100 * 10) / 10;
    });

    setDeliveryMapeData(newData);
  }, [JSON.stringify(deliveryMapeByTerminalDeliverType), JSON.stringify(deliveryList)]);
  useEffect(function () {
    if (!isMounted.current) isMounted.current = true;
    return function () {
      setDeliveryMapeData([]);
      setDeliveryList([]);
    };
  }, []);
  if (!isMounted.current) return null;
  var fields = {};

  _.set(fields, 'text', {
    label: t('lbl-model')
  });

  _.set(fields, 'mape', {
    label: t('lbl-mape'),
    formatter: function formatter(val, row) {
      return /*#__PURE__*/React.createElement("span", {
        className: parseInt(val) > 20 ? 'high' : ''
      }, val ? val + '%' : '');
    }
  }); // let fieldRight = {}
  // _.set(fieldRight, 'model', { label: t('lbl-model') })
  // _.set(fieldRight, 'count', { label: t('lbl-car-count') })


  return /*#__PURE__*/React.createElement("div", {
    id: id,
    className: "mape-card-block"
  }, /*#__PURE__*/React.createElement("div", {
    className: "head"
  }, /*#__PURE__*/React.createElement("span", {
    className: "title"
  }, t('lbl-delivery-time-model')), /*#__PURE__*/React.createElement("div", {
    className: "selector"
  }, /*#__PURE__*/React.createElement("label", {
    className: "label"
  }, t('lbl-gate-delivery'), ": "), /*#__PURE__*/React.createElement(DropDown, {
    defaultText: t('lbl-all-gate-delivery'),
    list: deliveryList,
    value: deliveryId,
    onChange: function onChange(val) {
      return handleDropDownChange(val);
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: "content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "c-border c-position-rlt dataTable-wrap"
  }, /*#__PURE__*/React.createElement(DataTable, {
    fields: fields,
    data: deliveryMapeData
  })), /*#__PURE__*/React.createElement(MapeDeliveryChart, null)));
});
MapeDelivery.defaultProps = {
  id: 'g-mape-delivery'
};
MapeDelivery.PropTypes = {
  id: PropTypes.string
};
export default MapeDelivery;